// removed by extract-text-webpack-plugin
module.exports = {"photoPickerButton":"PhotoPicker__photoPickerButton___A0pJW","photoPlaceholder":"PhotoPicker__photoPlaceholder___1YUHz","photoPlaceholderIcon":"PhotoPicker__photoPlaceholderIcon___1eBTV"};


//////////////////
// WEBPACK FOOTER
// ./src/PhotoPicker.css
// module id = 7
// module chunks = 0 1